import { NoResults, WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import { Hit, Loading } from '../components/news/results';
import initNewsSlider from '../../../components/NewsSlider';

const sliders = document.querySelectorAll('.news-slider');
if (sliders.length > 0) {
  const apiUrl = Craft.getSiteUrl('api/react/news');
  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
      } = data;

      const {
        news,
      } = translates;

      const hitClasses = 'swiper-slide p-0.5! w-85.5! md:w-86.25!';
      const hitClassesLoading = `${hitClasses} mr-4 md:mr-7.5 last:mr-0`;

      sliders.forEach((slider) => {
        const settings = (slider as HTMLElement)?.dataset || null;
        const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
        if (settings) {
          const indexName = settings.indexName || '';
              const itemCount = Number.parseInt(settings.count as string, 10);

              whiteInstantSearchCatalog
                .withSearchkit(
                  indexName,
                  settings.publicUrl || '',
                  settings.jwt || '',
                  settings.refreshUrl || '',
                )
                .addAdditionalData({
                  translates,
                  hitClasses,
                  hitClassesLoading,
                  itemCount,
                })
                .addHitComponent(
                  [
                    {
                      settings: {
                        noResults: {
                          translations: {
                            noResults: Craft.t(news, 'Sorry, we can\'t find any news!'),
                            refinements: Craft.t(news, 'Try to choose another category or filter.'),
                            query: Craft.t(news, 'Please try another query.'),
                          },
                        },
                      },
                      component: Hit as HitComponent,
                      loadingComponent: Loading as LoadingComponent,
                      noResultsComponent: NoResults,
                    },
                  ],
                  `#white-instant-search-hits-${settings.id}`,
                )
                .setHitsPerPage(itemCount)
                .setScrolling({
                  includeAttributes: ['page'],
                });

              if (settings.customRefinement) {
                whiteInstantSearchCatalog.whereQuery(settings.customRefinement);
              }

              whiteInstantSearchCatalog
                .afterFirstRender(() => initNewsSlider(settings.id))
                .build()
                .show();
        }
      });
    });
}